import { useEffect, useState } from "react";
import Card from "./Card";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import InfiniteScroll from "react-infinite-scroll-component";

let moviesData = [];
let pages = 1;
const key = "b55d580200c51623fe9608f8f064a09b";

const AllMovies = () => {
  // const [showMovies, setShowMovies] = useState([]);
  const [allMovies, setAllMovies] = useState([]);
  useEffect(() => {
    pages = 1;
    const getMovies = async () => {
      const response = await axios.get(
        `https://api.themoviedb.org/3/discover/movie?api_key=${key}&page=${pages}`
      );
      moviesData = response.data.results;
      pages++;
      const response2 = await axios.get(
        `https://api.themoviedb.org/3/discover/movie?api_key=${key}&page=${pages}`
      );
      const moviesData2 = [...moviesData, ...response2.data.results];
      setAllMovies([...moviesData2]);
    };
    getMovies();
  }, []);

  async function getMoreMovies() {
    const response = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=${key}&page=${pages}`
    );
    pages++;
    return response.data.results;
  }

  async function setMoreMovies() {
    const moreMovies = await getMoreMovies();
    setAllMovies((prevState) => {
      return [...prevState, ...moreMovies];
    });
  }

  return (
    <>
      <div className="main ">
        {/* MOVIES---------- */}
        <div
          className="movies-container my-3 pb-4 container-fluid"
          style={{ minHeight: "90vh" }}
        >
          {allMovies.length < 1 ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ width: "100%", height: "68vh" }}
            >
              <CircularProgress />
            </div>
          ) : (
            allMovies.map((movie, index) => {
              // if (index < 40) {
              // return <Card movie={movie} key={movie.id} />;
              return (
                <>
                  <Card movie={movie} key={movie.id} />
                </>
              );
              // }
            })
          )}
          <InfiniteScroll
            dataLength={allMovies.length}
            next={setMoreMovies}
            hasMore={true}
            endMessage={
              <p style={{ textAlign: "center" }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
          >
            {allMovies.map((movie, index) => {
              if (index > 40) {
                return <Card className="d-none" movie={movie} key={movie.id} />;
              }
            })}
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};
export default AllMovies;
